import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { FeatherCopy, FeatherCheck } from '@subframe/core';

interface WalletAddressProps {
  address: string;
  className?: string;
}

export const WalletAddress: React.FC<WalletAddressProps> = ({ address, className = '' }) => {
  const [copied, setCopied] = useState(false);
  const truncated = `${address.slice(0, 6)}...${address.slice(-4)}`;

  const handleCopy = async (e: React.MouseEvent) => {
    e.preventDefault();
    e.stopPropagation();
    await navigator.clipboard.writeText(address);
    setCopied(true);
    setTimeout(() => setCopied(false), 1500);
  };

  return (
    <span className={`inline-flex items-center gap-1 ${className}`}>
      <Link
        to={`/wallets/${address}`}
        className="font-mono text-brand-700 hover:text-brand-600 hover:underline"
        target="_blank"
        rel="noopener noreferrer"
      >
        {truncated}
      </Link>
      <button
        onClick={handleCopy}
        className="text-subtext-color hover:text-default-font transition-colors"
        title="Copy address"
      >
        {copied
          ? <FeatherCheck className="h-3 w-3 text-green-500" />
          : <FeatherCopy className="h-3 w-3" />
        }
      </button>
    </span>
  );
};
